//@ts-check
import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
    dropping: {
        border: '2px dashed #e7e8e9',
    },
}));

const DropZone = ({ component: Component, onDrop, className = '', ...props }) => {
    const classes = useStyles();

    const [isDropping, setDropping] = useState(false);

    const handleDragEvent = (e, isInDropZone) => {
        e.preventDefault();
        setDropping(isInDropZone);
    };

    const onDragEnter = (e) => handleDragEvent(e, true);
    const onDragExit = (e) => handleDragEvent(e, false);

    const handleDrop = (e) => {
        onDragExit(e);
        onDrop(e.dataTransfer.files);
    };

    return (
        <Component
            {...props}
            className={clsx(className, { [classes.dropping]: isDropping })}
            onDragEnter={onDragEnter}
            onDragOver={onDragEnter}
            onDragLeave={onDragExit}
            onDragExit={onDragExit}
            onDrop={handleDrop}
        >
            {props.children}
        </Component>
    );
};

export default DropZone;
